import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";
//import axios from 'axios';
import queryString from "query-string";
import ThemePartList from "../containers/theme/ThemePartList";
import Footer from "../components/Footer";

class ThemeList extends Component {
  state = {};

  render() {
    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);
    ////console.log(query)
    const themeSerial = query.ts;
    ////console.log(searchList)
    return (
      <Fragment>
        <ThemePartList themeSerial={themeSerial} />

        <Footer />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ThemeList));
